import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export class Counter {
  constructor() {
    this.isInitialized = false
    this.counters = []
  }

  init() {
    if (this.isInitialized) return

    const counterElements = document.querySelectorAll("[data-counter]")

    if (counterElements.length === 0) return

    counterElements.forEach((element, index) => {
      this.setupCounter(element, index)
    })

    this.isInitialized = true
  }

  setupCounter(element, index) {
    const finalNumber = element.textContent.trim()

    if (!this.isValidNumber(finalNumber)) return

    const counterData = {
      element,
      finalNumber,
      originalValue: this.parseNumberValue(finalNumber),
      currentValue: 0,
      hasDecimal: finalNumber.includes('.'),
      decimalPlaces: this.getDecimalPlaces(finalNumber),
      scrollTrigger: null
    }

    if (counterData.hasDecimal) {
      counterData.element.textContent = (0).toFixed(counterData.decimalPlaces)
    } else {
      const digitCount = Math.floor(counterData.originalValue).toString().length
      counterData.element.textContent = this.formatNumberWithLeadingZeros(0, digitCount)
    }

    this.counters.push(counterData)

    this.setupScrollTrigger(counterData, index)
  }

  isValidNumber(str) {
    return /^[\d,\.+]+$/.test(str)
  }

  getDecimalPlaces(numberStr) {
    const parts = numberStr.split('.')
    return parts.length > 1 ? parts[1].replace(/,/g, '').length : 0
  }

  parseNumberValue(numberStr) {
    const cleaned = numberStr.replace(/[,+]/g, '')
    return parseFloat(cleaned)
  }

  formatNumberWithLeadingZeros(num, totalDigits) {
    const numStr = num.toString().padStart(totalDigits, '0')
    return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  setupScrollTrigger(counterData, index) {
    counterData.scrollTrigger = ScrollTrigger.create({
      trigger: counterData.element,
      start: "top 80%",
      markers: false,
      onEnter: () => this.animateCounter(counterData),
      once: true,
      // markers: true
    })
  }

  animateCounter(counterData) {
    counterData.currentValue = 0

    gsap.to(counterData, {
      currentValue: counterData.originalValue,
      duration: 2,
      ease: "power2.out",
      onUpdate: () => {
        if (counterData.hasDecimal) {
          counterData.element.textContent = counterData.currentValue.toFixed(counterData.decimalPlaces)
        } else {
          const currentNum = Math.floor(counterData.currentValue)
          const digitCount = Math.floor(counterData.originalValue).toString().length
          counterData.element.textContent = this.formatNumberWithLeadingZeros(currentNum, digitCount)
        }
      }
    })
  }

  destroy() {
    this.counters.forEach(counterData => {
      if (counterData.scrollTrigger) {
        counterData.scrollTrigger.kill()
        counterData.scrollTrigger = null
      }
      counterData.element.textContent = counterData.finalNumber
    })

    this.counters = []
    this.isInitialized = false
  }

  refresh() {
    ScrollTrigger.refresh()
  }

  toggle(enabled = true) {
    this.counters.forEach(counterData => {
      if (counterData.scrollTrigger) {
        if (enabled) {
          counterData.scrollTrigger.enable()
        } else {
          counterData.scrollTrigger.disable()
        }
      }
    })
  }
}